import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
var Container = function (props) {
    var _a = props.children, children = _a === void 0 ? null : _a, justifyContent = props.justifyContent, _b = props.width, width = _b === void 0 ? null : _b, _c = props.mobileWidth, mobileWidth = _c === void 0 ? null : _c;
    return (_jsx(Box, { display: "flex", flexDirection: "row", justifyContent: justifyContent, children: _jsx(Box, { sx: { width: { xs: "".concat(mobileWidth, "%"), lg: "".concat(width, "%") } }, children: children }) }));
};
export default Container;
